export const createPlanIdForTheDiv = (planId: string) => `comparison_table_plan_${planId}`;
